import { render, staticRenderFns } from "./SmsValidation.vue?vue&type=template&id=30cda2f9&scoped=true"
import script from "./SmsValidation.vue?vue&type=script&lang=js"
export * from "./SmsValidation.vue?vue&type=script&lang=js"
import style0 from "./SmsValidation.vue?vue&type=style&index=0&id=30cda2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cda2f9",
  null
  
)

export default component.exports